@if ((hasCloneStarted$ | async) === false && hasPartialClonePermission()) {
  <section class="container" data-qa-id="clone-tenant-options-section">
    <div class="header-wrapper">
      <h1>Clone Tenant</h1>
      <div class="warning-message" data-qa-id="clone-tenant-text-warning">
        <mat-icon class="warning-icon">warning</mat-icon>
        This feature is still in development - Please do not use it until finished
      </div>
    </div>
    <div class="content-wrapper">
      <div class="clone-options-control">
        <label class="control-label" id="cloneOptionsRadioLabel">Choose a clone process option:</label>
        <mat-radio-group [(ngModel)]="cloneOption" aria-labelledby="cloneOptionsRadioLabel" data-qa-id="clone-tenant-radio-group"
          class="radio-cards-container">
          @for (option of cloneOptions; track option) {
            <app-radio-button-card [value]="option.value" [label]="option.label"
              [icon]="option.icon" [checked]="option.value === cloneOption"
              [class.checked]="option.value === cloneOption">
              <div class="description">
                <div class="description-title">{{ option.shortDescription }}</div>
                <div class="card-info">
                  <mat-icon [class]="option.descriptionIcon">{{ option.descriptionIcon }}</mat-icon>
                  <div>{{ option.info }}</div>
                </div>
              </div>
            </app-radio-button-card>
          }
        </mat-radio-group>
      </div>
    </div>
  </section>
}

<section class="container">
  <div class="header-wrapper">
    <h1>Clone Tenant @if (hasPartialClonePermission()) {
      <span>Options - {{ getCloneSelectedOptionName() }}</span>
    }
  </h1>
</div>


<div class="content-wrapper">
  @if ((cloneInProgress$ | async)) {
    <div class="console-container">
      <div class="console-header">
        <div class="console-title">Progress</div>
      </div>
      @if ((cloneJobId$ | async); as cloneJobId) {
        <job-liveview [jobId]="cloneJobId"
        (finished)="jobComplete($event)"></job-liveview>
      }
    </div>
  } @else {
    @switch (cloneOption) {
      @case ('ExportImport') {
        <app-clone-export-import></app-clone-export-import>
      }
      @case ('Export') {
        <app-clone-export-only></app-clone-export-only>
      }
      @case ('Import') {
        <app-clone-import-only></app-clone-import-only>
      }
    }
  }

</div>
</section>